import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import "../../../styles/Auth/category.css";
import "../../../styles/Auth/product.css";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Box, Modal, Button,
    Tooltip, Menu, MenuItem
} from '@mui/material';
import { Icon } from "@iconify/react";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import { postData, getData, putData, uploadFile, deleteData } from "../../../webService/webservice.js";
import { toast } from "react-toastify";
import ViewServiceCategoryPopup from './viewServiceCategoryPopUp.jsx';
import TVFMLoader from "../Loader/loader.jsx";
import { useStore } from "../../../Context/context.jsx";
import StoreMultiSelect from "../../Challange/storeMultiSelect.jsx";
import AddStoreForm from "../store/AddStoreForm.jsx";
import AddServiceCategoryForm from "./AddServiceCategoryForm.jsx";
import Footer from "../Footer/Footer-page.jsx";
import StockImagePicker from "../../../components/Common/ImagePicker/StockImagePicker.jsx";
import StoreSingleAllStoresSelect, { ALL_STORE_OPTION } from "../../Challange/StoreSingleAllStoresSelect.jsx";

const ServiceCategoryPage = () => {
    const EMPTY_ARRAY = [];
    const navigate = useNavigate();
    const location = useLocation();
    const isAddPage = location.pathname === '/services/category/add';
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId = adminStoreIds[0] || "";
    const [store, setStore] = useState(() => ({
        value: initialStoreId,
        label: initialStoreId === "" ? "All Stores" : "Loading..."
    }));
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        display: "flex",
        alignItems: 'center',
        justifyContent: "center"
    };
    const headings = [
        'S.No',
        'Image',
        'Name',
        'Action',
    ];
    const [isAddStore, setIsAddStore] = useState(false);

    const [categoryImage, setCategoryImage] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [categories, setCategories] = useState([]);
    const [viewCategoryData, setViewCategoryData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);

    const [stores, setStores] = useState([]);
    const [storeRefreshKey, setStoreRefreshKey] = useState(0);
    const sessionToken = localStorage.getItem("Token");
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const [open, setOpen] = useState(false);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editCategoryId, setEditCategoryId] = useState(null);
    const [categoryToDelete, setCategoryToDelete] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [limit, setLimit] = useState(5);
    const [refreshKey, setRefreshKey] = useState(0);
    const { selectedStoreId, setSelectedStoreId } = useStore();
    const [errors, setErrors] = useState({});
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);
    const [showLoader, setShowLoader] = useState(false);
    const [loaderText, setLoaderText] = useState('');
    const [uploadMethod, setUploadMethod] = useState("Normal");
    const [showStockPicker, setShowStockPicker] = useState(false);
    const [selectedStockImage, setSelectedStockImage] = useState(null);

    const fileInputRef = React.useRef(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(null);
    const isActionMenuOpen = Boolean(actionAnchorEl);
    const handleActionClick = (e) => setActionAnchorEl(e.currentTarget);
    const handleActionClose = () => setActionAnchorEl(null);

    const handleBulkUploadClick = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            const sid = (role === "SuperAdmin" || role === "SelfAdmin")
                ? store?.value
                : (Array.isArray(selectedStoreId) ? selectedStoreId[0] : selectedStoreId);

            const storeIdToUse = sid || (stores?.length === 1 ? stores[0]._id : null);

            if (!storeIdToUse) {
                alert("Please select a store before uploading service categories");
                return;
            }

            const formData = new FormData();
            formData.append("file", file);
            formData.append("storeIds", storeIdToUse);

            const response = await postData(
                `/servicecategories/bulkupload/${userId}`,
                formData,
                token,
                true
            );

            if (response?.success === false) {
                alert(response.message || "Bulk Upload Failed!");
            } else {
                alert("Bulk Service Category Upload Successful!");
                setRefreshKey(prev => prev + 1);
            }
        } catch (error) {
            console.error("Bulk Service Category Upload Failed:", error);
            alert(error?.response?.data?.message || "Error uploading file!");
        } finally {
            if (e.target) e.target.value = "";
        }
    };

    const handleDownloadSampleTemplate = async () => {
        const token = localStorage.getItem("Token");
        const sid = (role === "SuperAdmin" || role === "SelfAdmin")
            ? store?.value
            : (Array.isArray(selectedStoreId) ? selectedStoreId[0] : selectedStoreId);

        const storeIdToUse = sid || (stores?.length === 1 ? stores[0]._id : null);

        if (!storeIdToUse) {
            alert("Please select a store before downloading the sample template");
            return;
        }

        try {
            const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
            const response = await fetch(`${baseUrl}/servicecategories/sample-template/${storeIdToUse}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error("Failed to download template");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "ServiceCategories.xlsx";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Failed to generate sample template:", error);
            alert("Failed to generate sample template. Please try again.");
        }
    };
    const sort = [[sortField, sortOrder]];
    const handleSort = (field) => {
        const newOrder =
            sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;

        setSortField(field);
        setSortOrder(newOrder);
    };
    const [formData, setFormData] = useState({
        serviceCategoryName: '',
        serviceCategoryImageObject: '',
        storeId: initialStoreId,
        storeName: ""
    });

    useEffect(() => {
        const fetchStoreName = async () => {
            if (formData.storeId && !formData.storeName) {
                try {
                    const res = await getData(`stores/store/${formData.storeId}`, {}, sessionToken);
                    if (res?.data) {
                        setFormData(prev => ({
                            ...prev,
                            storeName: res.data.storeName
                        }));
                    }
                } catch (err) {
                    console.error("Failed to fetch store name", err);
                }
            }
        };
        fetchStoreName();
    }, [formData.storeId, formData.storeName]);

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const validateFields = (data, method, img, stockImg) => {
        let newErrors = {};
        if (!data.storeId) newErrors.storeId = "Store is required";
        if (method === "Normal" && img) {
            const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
            const allowedExtensions = ["jpg", "jpeg", "png"];
            const fileExtension = img.name.split('.').pop().toLowerCase();
            const isValidType = allowedTypes.includes(img.type) || allowedExtensions.includes(fileExtension);
            if (!isValidType) {
                newErrors.categoryImage = "Only JPEG, JPG, and PNG images are allowed.";
            } else if (img.size > 1024 * 1024) {
                newErrors.categoryImage = "Image size exceeds 1MB. Please select an image smaller than 1MB.";
            }
        }
        if (!data.serviceCategoryName?.trim()) newErrors.serviceCategoryName = "Category Name is required";
        return newErrors;
    };

    const handleUpdateCategory = async (e) => {
        e.preventDefault();
        const validationErrors = validateFields(formData, uploadMethod, categoryImage, selectedStockImage);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});
        setShowLoader(true);
        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            let updatedImageObject = null;
            if (uploadMethod === "Normal") {
                if (categoryImage && userId) {
                    const uploadResult = await uploadFile(`files/upload/${userId}`, categoryImage);
                    if (uploadResult?.status === 200 || uploadResult?.success) {
                        updatedImageObject = uploadResult.data;
                    } else {
                        toast.error(uploadResult?.message || "Image upload failed");
                        setShowLoader(false);
                        return;
                    }
                } else {
                    updatedImageObject = formData.serviceCategoryImageObject;
                }
            } else {
                updatedImageObject = selectedStockImage;
            }

            const updatedCategoryData = {
                serviceCategoryName: formData.serviceCategoryName,
                serviceCategoryImageObject: updatedImageObject,
                storeId: formData.storeId,
                imageSource: uploadMethod
            };

            const response = await putData(
                `servicecategories/service-category/${editCategoryId}`,
                updatedCategoryData,
                token
            );

            toast.success(response.message || "Service Category updated successfully");

            setFormData({
                serviceCategoryName: "",
                serviceCategoryImageObject: null
            });

            setCategoryImage(null);
            setPreviewUrl(null);
            setIsPopupMode(false);
            setIsEditMode(false);
            triggerRefresh();

        } catch (error) {
            console.error("Update Service Category Error:", error);
            toast.error("Error updating service category.");
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 2000);
        }
    };

    const handleRemoveImage = () => {
        setPreviewUrl(null);
        setCategoryImage(null);
        setSelectedStockImage(null);
        setFormData(prev => ({ ...prev, serviceCategoryImageObject: null }));
    };

    const handleStockSelect = (imageObject) => {
        if (!imageObject) return;
        setSelectedStockImage(imageObject);
        const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
        const uri = imageObject.uri || imageObject.fileObject?.uri || "";
        if (uri) {
            setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
        }
        setShowStockPicker(false);
        setErrors(prev => ({ ...prev, categoryImage: null }));
    };

    const handleViewCategory = async (categoryId) => {
        try {
            setLoading(true);
            const sessionToken = localStorage.getItem("Token");
            const response = await getData(`servicecategories/service-category/${categoryId}`, sessionToken);
            const data = response?.data || response;
            setViewCategoryData(data);
            setOpenViewPopup(true);
        } catch (error) {
            console.error("Error fetching service category:", error);
            toast.error(error.message || "Failed to fetch service category data");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteCategory = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('Token');
            const response = await deleteData(
                `servicecategories/service-category/${categoryToDelete}`,
                token
            );
            toast.success(response.message || "Service Category deleted successfully");
            setCategoryToDelete(null);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete service category");
        }
    };

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const params = {
                    page: currentPage,
                    limit: limit === 'all' ? 999999 : limit,
                    search: searchQuery?.trim() || "",
                    sort: JSON.stringify([[sortField, sortOrder]])
                };
                const sid = role === "SuperAdmin" || role === "SelfAdmin" ? store?.value : Array.isArray(selectedStoreId)
                    ? selectedStoreId[0]
                    : selectedStoreId;
                if (sid && sid.length === 24) {
                    params.storeId = sid;
                }

                const data = await getData('servicecategories/service-categories', params, sessionToken);
                if (data?.status !== 200) {
                    toast.error(data?.message || "Failed to fetch service categories");
                    return;
                }
                const results = data?.data?.results?.[0]?.paginatedResults || [];
                setCategories(results);
                setTotalPages(data?.data?.results?.[0]?.totalPages || 1);
                setTotalCount(data?.data?.results?.[0]?.totalCount || 0);
            } catch (error) {
                toast.error(error.message || "Failed to fetch service categories");
            }
        };
        fetchCategories();
    }, [currentPage, limit, refreshKey, searchQuery, selectedStoreId, sortField, sortOrder, store]);

    useEffect(() => {
        if (!isPopupMode && stores && stores.length === 1) {
            const onlyStore = stores[0]._id;
            setSelectedStoreId(onlyStore);
        }
    }, [stores, isPopupMode]);

    useEffect(() => {
        const handleStoreChange = () => {
            setCurrentPage(1);
        };
        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    const handleOpen = (categoryId) => {
        setCategoryToDelete(categoryId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCategoryToDelete(null);
    };

    const handlePageChange = (direction) => {
        setCurrentPage((prev) => {
            if (direction === "first") return 1;
            if (direction === "last") return totalPages;
            if (direction === "next") return Math.min(prev + 1, totalPages);
            if (direction === "prev") return Math.max(prev - 1, 1);
            return prev;
        });
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = localStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                const results = data?.data?.results || [];
                setStores(results);

                if (role === "Admin") {
                    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
                    if (adminStoreIds.length === 1) {
                        setFormData(prev => ({ ...prev, storeId: adminStoreIds[0] }));
                    }
                }
            } catch (error) {
                console.error("Failed to load stores", error);
            }
        };
        fetchStores();
    }, []);

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "stores/stores",
                { page, limit: 10, search: inputValue },
                sessionToken
            );

            const results = res?.data?.results || EMPTY_ARRAY;

            const options = results.map(store => ({
                value: store._id,
                label: store.storeName
            }));

            return {
                options,
                hasMore: results.length === 10,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Store Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    return (
        <div className="product-layout">
            <div className="product-content">
                {showLoader ? (
                    <div className="scissor-overlay">
                        <div className="scissor-loader"><TVFMLoader /></div>
                    </div>
                ) : (
                    <main className="product-main">
                        {isAddPage ? (
                            <AddServiceCategoryForm
                                onSuccess={() => {
                                    navigate("/services/category");
                                    triggerRefresh();
                                }}
                                onCancel={() => navigate('/services/category')}
                                initialStoreId={initialStoreId}
                            />
                        ) : (
                            <>
                                <Typography variant="h6" sx={{ mb: 2 }}>
                                    Service Categories
                                </Typography>
                                <div className="product-widgets">
                                    <div className="search-input-wrapper">
                                        <input
                                            type="text"
                                            placeholder="Search service categories..."
                                            className="category-search-input"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <Icon icon="mdi:magnify" className="search-icon" />
                                    </div>
                                    {(role === "SuperAdmin" || role === "SelfAdmin") && (
                                        <StoreSingleAllStoresSelect
                                            value={store}
                                            onChange={(store) => setStore(store)}
                                        />
                                    )}
                                      <div className="add-product-buttons">
                                          <button
                                              className="add-btn-product"
                                              onClick={() => fileInputRef.current?.click()}
                                          >
                                              Import
                                          </button>
                                          <button
                                              className="add-btn-product"
                                              onClick={() => navigate('/services/category/add')}
                                          >
                                              + Add Service Category
                                          </button>
                                          <button
                                              className="add-btn-product"
                                              onClick={handleDownloadSampleTemplate}
                                          >
                                              Download Sample Template
                                          </button>
                                      </div>
                                      <input
                                          type="file"
                                          accept=".xlsx, .xls"
                                          style={{ display: "none" }}
                                          ref={fileInputRef}
                                          onChange={handleBulkUploadClick}
                                      />
                                </div>
                                <Box component={Paper}>
                                    <TableContainer component={Paper} sx={{
                                        maxHeight: '400px',
                                        overflowY: "auto",
                                        '&::-webkit-scrollbar': { display: 'none' },
                                        scrollbarWidth: 'none',
                                        msOverflowStyle: 'none',
                                        boxShadow: 'none',
                                        backgroundColor: '#ffffffff',
                                    }}>
                                        <Table className="custom-category-table">
                                            <TableHead className="custom-product-head">
                                                <TableRow>
                                                    {headings.map((heading, index) => {
                                                        const isCategoryName = heading === "Name";
                                                        const sortKey = isCategoryName ? "serviceCategoryName" : null;

                                                        return (
                                                            <TableCell
                                                                key={index}
                                                                sx={{
                                                                    border: "none",
                                                                    padding: "12px 16px",
                                                                    textAlign: "center",
                                                                    position: "sticky",
                                                                    top: 0,
                                                                    zIndex: 10,
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        gap: "4px",
                                                                        color: "#ffffffff",
                                                                        fontSize: "14px",
                                                                        fontWeight: 600,
                                                                    }}
                                                                >
                                                                    {heading}
                                                                    {sortKey && (
                                                                        <span
                                                                            onClick={() => handleSort(sortKey)}
                                                                            style={{
                                                                                fontSize: "10px",
                                                                                color: "#ffffffff",
                                                                                cursor: "pointer",
                                                                                marginLeft: "4px",
                                                                                userSelect: "none",
                                                                            }}
                                                                        >
                                                                            {sortField === sortKey
                                                                                ? sortOrder === 1
                                                                                    ? "▲"
                                                                                    : "▼"
                                                                                : "▲▼"}
                                                                        </span>
                                                                    )}
                                                                </Typography>
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {categories.length === 0 ? (
                                                    <TableRow>
                                                        <TableCell colSpan={4}>
                                                            <Typography sx={{ textAlign: 'center', padding: '20px', fontWeight: 500 }}>
                                                                No service categories found.
                                                            </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                    categories.map((cat, index) => (
                                                        <TableRow key={cat._id}>
                                                            <TableCell>
                                                                <Typography sx={commonCellStyle}>
                                                                    {(currentPage - 1) * (limit === 'all' ? 0 : limit) + index + 1}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <img
                                                                        src={cat.serviceCategoryImageObject?.uri ? `${(process.env.REACT_APP_API_URL || "").replace(/\/+$/, "")}/${cat.serviceCategoryImageObject.uri.replace(/^\/+/, "")}` : "/assets/placeholder.png"}
                                                                        alt={cat.serviceCategoryName}
                                                                        onError={(e) => { e.target.onerror = null; e.target.src = "/assets/placeholder.png"; }}
                                                                        style={{ width: '50px', height: '50px', borderRadius: '8px', objectFit: 'cover' }}
                                                                    />
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Typography sx={commonCellStyle}>{cat.serviceCategoryName}</Typography>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                                    <Tooltip title="View Service Category">
                                                                        <Icon icon={plusIcon} width={20} height={20} style={{ cursor: 'pointer' }} onClick={() => handleViewCategory(cat._id)} />
                                                                    </Tooltip>
                                                                    <Tooltip title="Edit Service Category">
                                                                        <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                            const sId = cat.storeId?._id || cat.storeId || "";
                                                                            const sName = cat.storeId?.storeName || cat.storeDetails?.[0]?.storeName || stores.find(s => s._id === sId)?.storeName || "";

                                                                            setFormData({
                                                                                serviceCategoryName: cat.serviceCategoryName || '',
                                                                                storeId: sId,
                                                                                storeName: sName,
                                                                                serviceCategoryImageObject: cat.serviceCategoryImageObject
                                                                            });
                                                                            setPreviewUrl(
                                                                                cat?.serviceCategoryImageObject?.uri
                                                                                    ? `${process.env.REACT_APP_API_URL}${cat.serviceCategoryImageObject.uri}`
                                                                                    : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                                                                            );
                                                                            const method = cat.imageSource === "Stock" ? "Stock" : "Normal";
                                                                            setUploadMethod(method);

                                                                            if (method === "Stock") {
                                                                                setSelectedStockImage(cat.serviceCategoryImageObject);
                                                                            } else {
                                                                                setSelectedStockImage(null);
                                                                            }

                                                                            // ✅ Always set preview
                                                                            const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
                                                                            const uri = cat?.serviceCategoryImageObject?.uri || "";

                                                                            setPreviewUrl(
                                                                                uri ? `${baseUrl}/${uri.replace(/^\/+/, "")}` : "/assets/placeholder.png"
                                                                            );
                                                                            setEditCategoryId(cat._id);
                                                                            setIsPopupMode(true);
                                                                            setIsEditMode(true);
                                                                            setLoaderText("Updating Service Category...");
                                                                        }} />
                                                                    </Tooltip>
                                                                    {role !== "SelfAdmin" && (
                                                                        <Tooltip title="Delete Service Category">
                                                                            <Icon
                                                                                icon={deleteIcon}
                                                                                width={20}
                                                                                height={20}
                                                                                style={{ color: '#C10000', cursor: 'pointer' }}
                                                                                onClick={() => handleOpen(cat._id)}
                                                                            />
                                                                        </Tooltip>
                                                                    )}
                                                                </Box>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <div className="product-bottom">
                                        <div className="category-section show-entries">
                                            <span className="text-label">Show</span>
                                            <select className="entries-select"
                                                value={limit}
                                                onChange={handleItemsPerPageChange}
                                            >
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="all">All</option>
                                            </select>
                                            <span className="text-label">Entries</span>
                                        </div>
                                        <div className="category-section showing-range">
                                            {limit === 'all'
                                                ? `Showing all ${totalCount} entries`
                                                : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                            }
                                        </div>
                                        <div className="category-section spacer"></div>
                                        <div className="category-section pagination-buttons">
                                            <button
                                                className="pagination-btn"
                                                disabled={currentPage === 1}
                                                onClick={() => handlePageChange("first")}
                                            >
                                                <Icon icon="mdi:chevron-double-left" />
                                            </button>
                                            <button
                                                className="pagination-btn"
                                                disabled={currentPage === 1}
                                                onClick={() => handlePageChange("prev")}
                                            >
                                                <Icon icon="mdi:chevron-left" />
                                            </button>
                                            <button
                                                className="pagination-btn"
                                                disabled={currentPage === totalPages}
                                                onClick={() => handlePageChange("next")}
                                            >
                                                <Icon icon="mdi:chevron-right" />
                                            </button>
                                            <button
                                                className="pagination-btn"
                                                disabled={currentPage === totalPages}
                                                onClick={() => handlePageChange("last")}
                                            >
                                                <Icon icon="mdi:chevron-double-right" />
                                            </button>
                                        </div>
                                    </div>
                                </Box>
                                {isPopupMode && (
                                    <div className="popup-overlay">
                                        <div className="popup-wrapper">
                                            <Icon
                                                icon={closeIcon}
                                                className="popup-close-icon-outside"
                                                onClick={() => {
                                                    setIsPopupMode(false);
                                                    setIsEditMode(false);
                                                    setFormData({ serviceCategoryName: '', storeName: '', serviceCategoryImageObject: '' });
                                                    setPreviewUrl(null);
                                                    setLoaderText('');
                                                }}
                                            />
                                            <div className="popup-form">
                                                <Typography variant="h6" sx={{ textAlign: 'center', fontWeight: 500, mb: 4 }}>
                                                    {isEditMode ? "Edit Service Category" : "Add Service Category"}
                                                </Typography>
                                                <form className="popup-form-body" onSubmit={handleUpdateCategory}>
                                                    <div className="form-group-row">
                                                        <div className="form-group">
                                                            <label className="input-label">Store Name</label>
                                                            <StoreMultiSelect
                                                                value={formData.storeId ? [{ value: formData.storeId, label: formData.storeName }] : []}
                                                                onChange={(val) => {
                                                                    const selectedStoreId = val && val.length > 0 ? val[0].value : "";
                                                                    const selectedStoreName = val && val.length > 0 ? val[0].label : "";
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        storeId: selectedStoreId,
                                                                        storeName: selectedStoreName,
                                                                    }));
                                                                }}
                                                                loadStores={loadStores}
                                                                loggedInRole={role}
                                                                assignedStoreIds={adminStoreIds}
                                                                isMulti={false}
                                                                isDisabled={(role === "StoreAdmin" || role === "StoreManager") && adminStoreIds.length === 1}
                                                                onAddStore={() => setIsAddStore(true)}
                                                            />
                                                            {errors.storeId && <p className="field-error">{errors.storeId}</p>}
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="serviceCategoryName">Category Name</label>
                                                            <input
                                                                type="text"
                                                                id="serviceCategoryName"
                                                                placeholder="Enter category name"
                                                                value={formData.serviceCategoryName}
                                                                onChange={(e) => {
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        serviceCategoryName: e.target.value,
                                                                    }));
                                                                    setErrors(prev => ({ ...prev, serviceCategoryName: null }));
                                                                }}
                                                            />
                                                            {errors.serviceCategoryName && <p className="field-error">{errors.serviceCategoryName}</p>}
                                                        </div>

                                                    </div>
                                                    <div className="form-group-row">
                                                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                                                            <label className="input-label">Category Image (Max 1MB, JPEG/JPG/PNG only)</label>
                                                            <div className="upload-options" style={{ display: 'flex', gap: '20px', marginBottom: '12px' }}>
                                                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                                                    <input
                                                                        type="radio"
                                                                        name="uploadMethod"
                                                                        checked={uploadMethod === "Normal"}
                                                                        style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                                                        onChange={() => {
                                                                            setUploadMethod("Normal");
                                                                            if (categoryImage) {
                                                                                setPreviewUrl(URL.createObjectURL(categoryImage));
                                                                            } else if (formData.serviceCategoryImageObject?.uri) {
                                                                                setPreviewUrl(`${process.env.REACT_APP_API_URL}${formData.serviceCategoryImageObject.uri}`);
                                                                            } else {
                                                                                setPreviewUrl(null);
                                                                            }
                                                                        }}
                                                                    />
                                                                    Normal Upload
                                                                </label>
                                                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                                                    <input
                                                                        type="radio"
                                                                        name="uploadMethod"
                                                                        checked={uploadMethod === "Stock"}
                                                                        style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                                                        onChange={() => {
                                                                            setUploadMethod("Stock");
                                                                            if (selectedStockImage) {
                                                                                const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
                                                                                const uri = selectedStockImage.uri || selectedStockImage.fileObject?.uri || "";
                                                                                setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
                                                                            } else {
                                                                                setPreviewUrl(null);
                                                                            }
                                                                        }}
                                                                    />
                                                                    Stock Image
                                                                </label>
                                                            </div>

                                                            {uploadMethod === "Normal" ? (
                                                                <input
                                                                    type="file"
                                                                    id="categoryImage"
                                                                    className="category-input"
                                                                    accept=".jpeg,.jpg,.png"
                                                                    onChange={(e) => {
                                                                        const file = e.target.files[0];
                                                                        if (file) {
                                                                            const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
                                                                            const allowedExtensions = ["jpg", "jpeg", "png"];
                                                                            const fileExtension = file.name.split('.').pop().toLowerCase();
                                                                            const isValidType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExtension);

                                                                            if (!isValidType) {
                                                                                setErrors(prev => ({ ...prev, categoryImage: "Only JPEG, JPG, and PNG images are allowed." }));
                                                                                toast.error("Only JPEG, JPG, and PNG images are allowed.");
                                                                                setCategoryImage(null);
                                                                                setPreviewUrl(null);
                                                                                if (e.target) e.target.value = "";
                                                                            } else if (file.size > 1024 * 1024) {
                                                                                setErrors(prev => ({ ...prev, categoryImage: "Image size exceeds 1MB. Please select an image smaller than 1MB." }));
                                                                                toast.error("Image size exceeds 1MB. Please select an image smaller than 1MB.");
                                                                                setCategoryImage(null);
                                                                                setPreviewUrl(null);
                                                                                if (e.target) e.target.value = "";
                                                                            } else {
                                                                                setCategoryImage(file);
                                                                                setPreviewUrl(URL.createObjectURL(file));
                                                                                setErrors(prev => ({ ...prev, categoryImage: null }));
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                            ) : (
                                                                <div className="stock-picker-trigger">
                                                                    <button
                                                                        type="button"
                                                                        className="select-stock-btn"
                                                                        onClick={() => setShowStockPicker(true)}
                                                                        style={{
                                                                            width: '100%',
                                                                            padding: '8px 12px',
                                                                            background: '#fff',
                                                                            border: '1px solid #ccc',
                                                                            borderRadius: '6px',
                                                                            cursor: 'pointer',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            textAlign: 'left',
                                                                            justifyContent: 'flex-start',
                                                                            gap: '10px',
                                                                            fontSize: '14px',
                                                                            color: selectedStockImage ? '#333' : '#888'
                                                                        }}
                                                                    >
                                                                        <Icon icon="mdi:image-search" style={{ fontSize: '18px', color: '#64748b' }} />
                                                                        {selectedStockImage ? `Selected: ${selectedStockImage.name || 'Stock Image'}` : "Click to select a stock image..."}
                                                                    </button>
                                                                </div>
                                                            )}
                                                            {errors.categoryImage && <p className="field-error">{errors.categoryImage}</p>}
                                                            {previewUrl && (
                                                                <div className="image-preview" style={{ marginTop: '12px', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                                                    <div style={{ position: 'relative' }}>
                                                                        <img src={previewUrl} alt="Preview" style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }} />
                                                                        <div
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: '-8px',
                                                                                right: '-8px',
                                                                                background: '#ef4444',
                                                                                color: 'white',
                                                                                borderRadius: '50%',
                                                                                width: '20px',
                                                                                height: '20px',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                cursor: 'pointer',
                                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                                                zIndex: 5
                                                                            }}
                                                                            onClick={handleRemoveImage}
                                                                            title="Remove image"
                                                                        >
                                                                            <Icon icon="mdi:close" style={{ fontSize: '14px' }} />
                                                                        </div>
                                                                    </div>
                                                                    {uploadMethod === "Stock" && selectedStockImage && (
                                                                        <div style={{ paddingTop: '4px' }}>
                                                                            <p style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b', margin: '0' }}>Stock Image Selected</p>
                                                                            <p style={{ fontSize: '11px', color: '#64748b', margin: '2px 0 0' }}>{selectedStockImage.name}</p>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="form-actions">
                                                        <button type="submit" className="add-Product-button">
                                                            {isEditMode ? "Update Category" : "Add Category"}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="cancel-Product-button"
                                                            onClick={() => setIsPopupMode(false)}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <Modal
                                    open={open}
                                    onClose={handleClose}
                                >
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            width: 380,
                                            background: "linear-gradient(135deg, #ffffff, #faf5f6)",
                                            borderRadius: "20px",
                                            boxShadow: "0 25px 70px rgba(0,0,0,0.35)",
                                            p: 4,
                                            outline: "none",
                                            textAlign: "center",
                                            overflow: "hidden"
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 74,
                                                height: 74,
                                                borderRadius: "50%",
                                                background: "#3C0008",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                margin: "0 auto 16px auto",
                                                color: "#fff",
                                                fontSize: 30,

                                                boxShadow: "0 12px 28px rgba(26,30,39,0.55)",
                                                animation: "deletePulse 1.6s infinite ease-in-out",

                                                "@keyframes deletePulse": {
                                                    "0%": {
                                                        transform: "scale(1)",
                                                        boxShadow: "0 0 0 0 rgba(26,30,39,0.7)",
                                                    },
                                                    "70%": {
                                                        transform: "scale(1.1)",
                                                        boxShadow: "0 0 0 18px rgba(26,30,39,0)",
                                                    },
                                                    "100%": {
                                                        transform: "scale(1)",
                                                        boxShadow: "0 0 0 0 rgba(26,30,39,0)",
                                                    },
                                                },
                                            }}
                                        >
                                            🗑️
                                        </Box>
                                        <Typography variant="h6" sx={{ fontWeight: 700, color: "#2b2b2b" }}>
                                            Confirm Delete
                                        </Typography>
                                        <Typography sx={{ mt: 1.2, fontSize: 14, color: "#666", lineHeight: 1.6 }}>
                                            Are you sure you want to delete this service category?
                                        </Typography>
                                        <Box sx={{ display: "flex", justifyContent: "center", gap: 2.5, mt: 3.5 }}>
                                            <Button variant="contained" onClick={handleDeleteCategory} className="add-Product-button">
                                                Yes, Delete
                                            </Button>
                                            <Button variant="outlined" onClick={handleClose} className="cancel-Product-button">
                                                Cancel
                                            </Button>
                                        </Box>
                                    </Box>
                                </Modal>
                                {openViewPopup && (
                                    <ViewServiceCategoryPopup
                                        data={viewCategoryData}
                                        onClose={() => setOpenViewPopup(false)}
                                    />
                                )}
                            </>
                        )}
                        {isAddStore && (
                            <div className="popup-overlay">
                                <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                                    <Icon icon={closeIcon} className="popup-close-icon-outside" onClick={() => setIsAddStore(false)} />
                                    <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                                        <AddStoreForm
                                            onSuccess={() => {
                                                setIsAddStore(false);
                                                setStoreRefreshKey(prev => prev + 1);
                                            }}
                                            onCancel={() => setIsAddStore(false)}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        {showStockPicker && (
                            <StockImagePicker
                                onSelect={handleStockSelect}
                                onCancel={() => setShowStockPicker(false)}
                            />
                        )}
                    </main>
                )}
                <Footer />
            </div>
        </div>
    );
};

export default ServiceCategoryPage;
